<template>
  <div class="back-button-container">
    <Button type="transparent" :text="$t('button.back')" link="products" target="_self" />
  </div>

  <div class="product-page-container" v-if="!loading">
    
    <section class="hero-section">
      <div class="hero-image-wrapper">
        <img v-if="productData.heroImage" :src="productData.heroImage" alt="Ürün Ana Görsel" class="main-product-img" />
      </div>
      <div class="hero-text-wrapper">
        <h1 class="product-title">{{ productData.detailTitle || productData.title }}</h1>
        <p class="product-desc">{{ productData.detailDesc }}</p>
      </div>
    </section>

    <section class="tech-specs-section">
      <div class="specs-text-wrapper">
        <h2 class="section-title">Teknik özellikler</h2>
        <ul class="specs-list">
          <li v-for="(spec, index) in techSpecsList" :key="index" data-aos="fade-up" :data-aos-delay="index * 100">
            {{ spec }}
          </li>
        </ul>
      </div>
      <div class="specs-image-wrapper" data-aos="fade-left">
        <img v-if="productData.wireframeImage" :src="productData.wireframeImage" alt="Teknik Çizim" class="wireframe-img" />
      </div>
    </section>

    <section class="tech-parts-section" v-if="productData.part1Title || productData.part2Title || productData.part3Title">
      <h2 class="section-title text-center">Teknik Parçalar</h2>
      <div class="parts-grid">
        
        <div class="part-item has-border" data-aos="fade-up" data-aos-delay="200" v-if="productData.part1Title">
          <img v-if="productData.part1Image" :src="productData.part1Image" :alt="productData.part1Title" />
          <h3>{{ productData.part1Title }}</h3>
        </div>
        
        <div class="part-item has-border" data-aos="fade-up" data-aos-delay="400" v-if="productData.part2Title">
          <img v-if="productData.part2Image" :src="productData.part2Image" :alt="productData.part2Title" />
          <h3>{{ productData.part2Title }}</h3>
        </div>
        
        <div class="part-item" data-aos="fade-up" data-aos-delay="600" v-if="productData.part3Title">
          <img v-if="productData.part3Image" :src="productData.part3Image" :alt="productData.part3Title" />
          <h3>{{ productData.part3Title }}</h3>
        </div>

      </div>
    </section>

    <footer class="product-footer">
      <div class="footer-left">
        <img src="@/assets/images/adminlogo.png" alt="BAUMIND Logo" class="footer-logo" />
      </div>
      <div class="footer-right">
        <!-- 2022 sabit yazısı dinamik hale getirildi -->
        <p>© {{ new Date().getFullYear() }} <strong>BAU İnovasyon ve Danışmanlık A.Ş.</strong></p>
        <p class="rights-text">Tüm Hakları Saklıdır</p>
      </div>
    </footer>

  </div>

  <div v-else class="product-page-container loading-state">
    <h3 style="color: white;">Ürün Detayları Yükleniyor...</h3>
  </div>
</template>

<script>
import Button from "@/components/common/Button.vue";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { initializeApp, getApps, getApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBxpNV_8UazGQ3pMReWWIdROn7AZlMT17Y",
  authDomain: "baumind-45d99.firebaseapp.com",
  projectId: "baumind-45d99",
  storageBucket: "baumind-45d99.firebasestorage.app",
  messagingSenderId: "982282716223",
  appId: "1:982282716223:web:25ebcf827c8e87c555248a",
  measurementId: "G-FDZLC80DZ2"
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const db = getFirestore(app);

export default {
  name: "ProductsPage",
  components: { Button },
  data() {
    return { productData: {}, techSpecsList: [], loading: true };
  },
  async mounted() { await this.fetchProductDetail(); },
  watch: { '$route.params.id'() { this.fetchProductDetail(); } },
  methods: {
    async fetchProductDetail() {
      this.loading = true;
      const routeId = this.$route.params.id; 
      if (!routeId) { this.loading = false; return; }

      try {
        const querySnapshot = await getDocs(collection(db, "urunler"));
        let matchedDoc = null;
        querySnapshot.forEach((docSnap) => {
          if (docSnap.id.toLowerCase() === routeId.toLowerCase()) { matchedDoc = docSnap; }
        });

        if (matchedDoc && matchedDoc.exists()) {
          const data = matchedDoc.data();
          this.productData = data;
          if (data.techSpecs) { this.techSpecsList = data.techSpecs.split('\n').filter(l => l.trim() !== ''); }
        }
      } catch (error) { console.error("Hata:", error); } finally { this.loading = false; }
    }
  }
};
</script>

<style scoped>
.back-button-container { width: 150px; color: white; margin-top: 5%; margin-left: 5%; margin-bottom: 20px; }
.product-page-container { background-color: #121619; width: 100%; min-height: 100vh; font-family: "DM Sans", sans-serif; color: aliceblue; padding: 0 8% 2% 8%; display: flex; flex-direction: column; box-sizing: border-box; }
.loading-state { display: flex; justify-content: center; align-items: center; }
.hero-section { display: flex; flex-direction: row; align-items: center; justify-content: space-between; min-height: 70vh; margin-bottom: 50px; }
.hero-image-wrapper { flex: 1; display: flex; justify-content: center; align-items: center; }
.main-product-img { max-width: 90%; height: auto; object-fit: contain; }
.hero-text-wrapper { flex: 1; padding-left: 5%; }
.product-title { font-size: 45px; font-weight: 500; margin-bottom: 30px; color: #fff; }
.product-desc { font-size: 18px; line-height: 1.7; color: #a9a7a7; max-width: 600px; }
.tech-specs-section { display: flex; flex-direction: row; align-items: center; justify-content: space-between; min-height: 60vh; margin-bottom: 80px; }
.specs-text-wrapper { flex: 1; padding-right: 5%; }
.section-title { font-size: 32px; font-weight: 500; margin-bottom: 40px; color: #fff; }
.text-center { text-align: center; }
.specs-list { list-style-type: none; padding-left: 0; }
.specs-list li { font-size: 16px; color: #a9a7a7; line-height: 1.6; margin-bottom: 18px; position: relative; padding-left: 20px; }
.specs-list li::before { content: "•"; color: #888; font-size: 24px; position: absolute; left: 0; top: -4px; }
.specs-image-wrapper { flex: 1; display: flex; justify-content: flex-end; }
.wireframe-img { max-width: 70%; height: auto; opacity: 0.8; }
.tech-parts-section { padding-top: 50px; padding-bottom: 80px; }
.parts-grid { display: flex; flex-direction: row; justify-content: space-between; align-items: flex-start; margin-top: 60px; }
.part-item { flex: 1; display: flex; flex-direction: column; align-items: center; text-align: center; padding: 0 20px; }
.has-border { border-right: 1px solid rgba(255, 255, 255, 0.1); }
.part-item img { height: 250px; width: auto; object-fit: contain; margin-bottom: 15px; }

/* display: none kaldırıldı ve isimler görünür hale getirildi */
.part-item h3 { font-size: 20px; font-weight: 400; color: #a9a7a7; margin: 0; }

/* FOOTER STİLLERİ */
.product-footer { display: flex; justify-content: space-between; align-items: center; padding-top: 30px; margin-top: auto; border-top: 1px solid rgba(255, 255, 255, 0.1); }
.footer-logo { height: 60px; width: auto; object-fit: contain; opacity: 0.8; }
.footer-right { text-align: right; font-size: 14px; color: #888; }
.footer-right p { margin: 5px 0; }
.rights-text { color: #555; }

@media screen and (max-width: 1024px) {
  .hero-section { flex-direction: column; text-align: center; margin-top: 40px; }
  .hero-text-wrapper { padding-left: 0; margin-top: 40px; }
  .tech-specs-section { flex-direction: column; }
  .specs-text-wrapper { padding-right: 0; margin-bottom: 50px; }
  .specs-image-wrapper { justify-content: center; }
  .parts-grid { flex-direction: column; gap: 50px; }
  .has-border { border-right: none; border-bottom: 1px solid rgba(255, 255, 255, 0.1); padding-bottom: 40px; }
  .product-footer { flex-direction: column; gap: 20px; text-align: center; }
  .footer-right { text-align: center; }
}
</style>